export const gitCommit = 'e14de073'
